import { Controller } from "@hotwired/stimulus"

// Controller for filtering match cards on the matches page
export default class extends Controller {
  static targets = ["matchCard", "filterBtn", "roundSection"]
  static values = {
    active: { type: String, default: "all" }
  }

  connect() {
    // Apply initial filter if any
    this.updateButtonStyles()
  }

  filter(event) {
    const filterType = event.currentTarget.dataset.filter
    this.activeValue = filterType
    this.applyFilter()
    this.updateButtonStyles()
  }

  applyFilter() {
    const filter = this.activeValue

    this.matchCardTargets.forEach(card => {
      const matchType = card.dataset.matchType

      if (filter === "all" || matchType === filter) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    // Hide round sections that have no visible matches
    this.hideEmptyRoundSections()
  }

  hideEmptyRoundSections() {
    // Find all round section containers (parent divs with bg-white rounded-lg shadow-lg)
    const roundSections = this.element.querySelectorAll('.space-y-8 > div')

    roundSections.forEach(section => {
      const visibleCards = section.querySelectorAll('[data-match-filter-target="matchCard"]:not(.hidden)')

      if (visibleCards.length === 0) {
        section.classList.add("hidden")
      } else {
        section.classList.remove("hidden")
      }
    })
  }

  updateButtonStyles() {
    const activeFilter = this.activeValue

    this.filterBtnTargets.forEach(btn => {
      const btnFilter = btn.dataset.filter

      // Reset all buttons to inactive state
      btn.classList.remove(
        "bg-blue-600", "text-white", "shadow-md",
        "bg-orange-600", "text-orange-700", "border-orange-300",
        "bg-yellow-600", "text-yellow-700", "border-yellow-300",
        "bg-green-600", "text-green-700", "border-green-300",
        "bg-gray-600", "text-gray-700", "border-gray-300"
      )

      if (btnFilter === activeFilter) {
        // Active state - filled button
        switch(btnFilter) {
          case "all":
            btn.classList.add("bg-blue-600", "text-white", "shadow-md")
            break
          case "a_saisir":
            btn.classList.add("bg-orange-600", "text-white", "shadow-md")
            break
          case "en_attente":
            btn.classList.add("bg-gray-600", "text-white", "shadow-md")
            break
          case "en_cours":
            btn.classList.add("bg-yellow-600", "text-white", "shadow-md")
            break
          case "termine":
            btn.classList.add("bg-green-600", "text-white", "shadow-md")
            break
        }
      } else {
        // Inactive state - outlined button
        switch(btnFilter) {
          case "all":
            btn.classList.add("bg-white", "text-blue-700", "border-2", "border-blue-300")
            break
          case "a_saisir":
            btn.classList.add("bg-white", "text-orange-700", "border-2", "border-orange-300")
            break
          case "en_attente":
            btn.classList.add("bg-white", "text-gray-700", "border-2", "border-gray-300")
            break
          case "en_cours":
            btn.classList.add("bg-white", "text-yellow-700", "border-2", "border-yellow-300")
            break
          case "termine":
            btn.classList.add("bg-white", "text-green-700", "border-2", "border-green-300")
            break
        }
      }
    })
  }
}
